<template>
    <Toggle
        v-model="value"
        :on-label="on_label"
        :off-label="off_label"
        @update:modelValue="handleInput"
    />
</template>

<script setup>
import { ref } from "vue";
import Toggle from "@vueform/toggle";

const props = defineProps({
    context: Object,
});

const on_label = props.context.on_label;
const off_label = props.context.off_label;
const value = ref(props.context.value == "true" ? true : false);

function handleInput(modelData) {
    props.context.node.input(modelData ? "true" : "false");
}
</script>
<style lang="css">
:root {
    --toggle-width: 4rem;
    --toggle-height: 1.5rem;
    --toggle-border: 0.5rem;
    --toggle-font-size: 1rem;
    --toggle-duration: 150ms;
    --toggle-bg-on: #10b981;
    --toggle-bg-off: #e5e7eb;
    --toggle-bg-on-disabled: #d1d5db;
    --toggle-bg-off-disabled: #e5e7eb;
    --toggle-border-on: #10b981;
    --toggle-border-off: #e5e7eb;
    --toggle-border-on-disabled: #d1d5db;
    --toggle-border-off-disabled: #e5e7eb;
    --toggle-ring-width: 0px;
    --toggle-ring-color: #10b98130;
    --toggle-text-on: #ffffff;
    --toggle-text-off: #374151;
    --toggle-text-on-disabled: #9ca3af;
    --toggle-text-off-disabled: #9ca3af;
    --toggle-handle-enabled: #ffffff;
    --toggle-handle-disabled: #f3f4f6;
}

.toggle-container {
    margin-bottom: var(--spacing);
}
</style>
<style src="@vueform/toggle/themes/default.css"></style>
